// src/com/bbs_pkg/BbsPkg.js
import React, { useEffect, useState } from 'react';
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import AnnounceBbs from './announce_bbs/AnnounceBbs';
import UpdateBbs from './update_bbs/UpdateBbs';
import VehAllocBbs from './veh_alloc_bbs/VehAllocBbs';
import UserBbsInfo from './user_bbs/UserBbsInfo';
import { AppMenuUrl } from '../../value/AppConst';

export default function BbsPkg({
    menu, parentMenu
}) {
    const [mountedViews, setMountedViews] = useState(() => ({
        [menu.menuUrl]: true,
    }));

    useEffect(() => {
        setMountedViews((prev) => {
            if(prev[menu.menuUrl]) return prev;
            return {...prev, [menu.menuUrl]: true};
        });
    }, [menu.menuUrl]);

    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        if(sib) {
            setMountedViews((prev) => {
                if(prev[sib.menuUrl]) return prev;
                return {...prev, [sib.menuUrl]: true};
            });
        }
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = parentMenu
    ? <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />
    : null;

    // 공지사항, 배차현황 게시판, 업데이트 게시판, 사용자 게시판
    return(
        <TopViewControl>
            {mountedViews[AppMenuUrl.Bbs] &&
                <AnnounceBbs
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.Bbs}
                />
            }
            {mountedViews[AppMenuUrl.VehBbs] &&
                <VehAllocBbs
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.VehBbs}
                />
            }
            {mountedViews[AppMenuUrl.BackBbs] &&
                <UpdateBbs
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.BackBbs}
                />
            }
            {mountedViews[AppMenuUrl.UserBbs] &&
                <UserBbsInfo
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.UserBbs}
                />
            }
        </TopViewControl>
    );
}
